module.exports = __webpack_public_path__ + "static/media/GCI.c4f381e8.png";